import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import GenericTableComponent from "../common/Table";
import {
  approveRejectCampaign,
  // statusCampaign,
  // getCpaByCampaignId,
  // updateCampaignCpa,
} from "../../redux/slices/campaignSlice";
import { getTopCampaigns } from "../../redux/slices/dashboardSlice";
import Swal from "sweetalert2";

const columns = [
  { id: "campaignName", label: "Campaign Name" },
  { id: "advertiser", label: "Advertiser" },
  { id: "campaignReference", label: "Reference" },
  { id: "createdAt", label: "Date created" },
  //{ id: "isApproved", label: "Approval" },
  { id: "campaignBudget", label: "Budget" },
  { id: "totalConversion", label: "Conversions" },
  { id: "reach", label: "Clicks" },
  { id: "conversionRate", label: "CR" },
  { id: "eCPM", label: "eCPM" },
];

const CampaignTable = () => {
  const dispatch = useDispatch();
  //const { campaigns } = useSelector((state) => state.campaign);
  const { topCampaigns, loading } = useSelector((state) => state.dashboard);
  //const { campaignCpa } = useSelector((state) => state.campaign);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    dispatch(getTopCampaigns({ page, rowsPerPage }));
  }, [dispatch, page, rowsPerPage]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleApproveClick = (id) => {
    Swal.fire({
      title: "Approve Campaign",
      html: `
        <label for="publisherCPA" style="display:block; margin-bottom:5px;">Publisher CPA</label>
        <input id="publisherCPA" type="text" class="swal2-input" placeholder="Enter Publisher CPA">
        <label for="campaignCPA" style="display:block; margin-top:15px; margin-bottom:5px;">Campaign CPA</label>
        <input id="campaignCPA" type="text" class="swal2-input" placeholder="Enter Campaign CPA">
      `,
      confirmButtonText: "Approve",
      showCancelButton: true,
      preConfirm: () => {
        const publisherCPA = document.getElementById("publisherCPA").value;
        const campaignCPA = document.getElementById("campaignCPA").value;

        if (!publisherCPA || !campaignCPA) {
          Swal.showValidationMessage("Both CPA values are required!");
          return;
        }

        return {
          state: "APPROVED",
          publisherCPA: publisherCPA,
          campaignCPA: campaignCPA,
          note: "",
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        //console.log(result)
        //return
        dispatch(approveRejectCampaign({ id, ...result.value }))
          .unwrap()
          .then(() => {
            dispatch(getTopCampaigns({ page, rowsPerPage }));
          })
          .catch((error) => {
            console.error("Failed to approve campaign:", error);
          });
      }
    });
  };

  const handleRejectClick = (id) => {
    Swal.fire({
      title: "Reject Campaign",
      html: `
        <label for="reason" style="display:block; margin-bottom:5px;">Reason</label>
        <textarea id="reason" class="swal2-textarea" placeholder="Enter reason for rejection"></textarea>
      `,
      confirmButtonText: "Reject",
      showCancelButton: true,
      preConfirm: () => {
        const note = document.getElementById("reason").value;

        if (!note) {
          Swal.showValidationMessage("Reason is required!");
          return;
        }

        return {
          state: "REJECTED",
          publisherCPA: "0",
          campaignCPA: "0",
          note,
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        //console.log(result)
        //return
        dispatch(approveRejectCampaign({ id, ...result.value }))
          .unwrap()
          .then(() => {
            dispatch(getTopCampaigns({ page, rowsPerPage }));
          })
          .catch((error) => {
            console.error("Failed to reject campaign:", error);
          });
      }
    });
  };
  // const handlePause = (id) => {
  //   dispatch(statusCampaign(id))
  //     .unwrap()
  //     .then(() => {
  //       dispatch(getTopCampaigns({ page, rowsPerPage }));
  //     })
  //     .catch((error) => {
  //       console.error("Failed to reject campaign:", error);
  //     });
  // };

  // const updateCpa = async (id) => {
  //   await dispatch(getCpaByCampaignId(id)).unwrap();

  //   const { costPerUserCampaign, costPerUserPublisher } = campaignCpa; // Extract the CPA values

  //   if (campaignCpa) {
  //     Swal.fire({
  //       title: "Update CPA",
  //       html: `
  //     <label for="publisherCPA" style="display:block; margin-bottom:5px;">Publisher CPA</label>
  //     <input id="publisherCPA" type="text" class="swal2-input" value="${costPerUserPublisher}" placeholder="Enter Publisher CPA">
  //     <label for="campaignCPA" style="display:block; margin-top:15px; margin-bottom:5px;">Campaign CPA</label>
  //     <input id="campaignCPA" type="text" class="swal2-input" value="${costPerUserCampaign}" placeholder="Enter Campaign CPA">
  //   `,
  //       confirmButtonText: "Update",
  //       showCancelButton: true,
  //       preConfirm: () => {
  //         const publisherCPA = document.getElementById("publisherCPA").value;
  //         const campaignCPA = document.getElementById("campaignCPA").value;

  //         // if (!publisherCPA || !campaignCPA) {
  //         //   Swal.showValidationMessage("Both CPA values are required!");
  //         //   return;
  //         // }

  //         return {
  //           costPerUserPublisher: parseFloat(publisherCPA),
  //           costPerUserCampaign: parseFloat(campaignCPA),
  //         };
  //       },
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         dispatch(updateCampaignCpa({ id, ...result.value }))
  //           .unwrap()
  //           .then(() => {
  //             dispatch(getTopCampaigns({ page, rowsPerPage }));
  //             dispatch(getCpaByCampaignId(id));
  //             Swal.fire("Success", "CPA updated successfully!", "success");
  //           })
  //           .catch((error) => {
  //             console.error("Failed to update CPA:", error);
  //           });
  //       }
  //     });
  //   }
  // };

  const filteredCampaigns = topCampaigns?.slice(0, 5);

  return (
    <div style={{ padding: "0" }}>
      {loading ? (
        <div> </div>
      ) : filteredCampaigns?.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          No campaigns available.
        </div>
      ) : (
        <GenericTableComponent
          columns={columns}
          data={filteredCampaigns}
          viewLink="/view-campaign"
          editLink="/edit-campaign"
          //publisherLink="/publisher-link"
          page={page}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
          //totalItems={meta?.itemCount || 0}
          handleApproveClick={handleApproveClick}
          handleRejectClick={handleRejectClick}
          // handlePause={handlePause}
          // updateCpa={updateCpa}
          hideApprove
          hideReject
          hideEdit
        />
      )}
    </div>
  );
};

export default CampaignTable;
